import { render, staticRenderFns } from "./MeTabs.vue?vue&type=template&id=07eb08b0"
import script from "./MeTabs.vue?vue&type=script&lang=js"
export * from "./MeTabs.vue?vue&type=script&lang=js"
import style0 from "./MeTabs.vue?vue&type=style&index=0&id=07eb08b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports